import React, { useEffect, useState } from "react";
import { Main, Content } from "../../components/Layout";
import { Table, Dropdown, Col, Row } from "react-bootstrap";
import MenuUser from "../../components/MenuUser";
import { formatDate } from "../../util/functions";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
import Avatar from "../../components/Avatar";
import IcEditar from "../../components/Svg/IcEditar";
import styles from "./styles.module.css";
import tableStyle from "../../components/Table/Table.module.css";
import styleButton from "../../components/Button/Button.module.css";
import Loading from "../../components/Loading";

export default function Users() {
  const { config } = useWrapper();
  const navigate = useNavigate();
  const [loadingPage, setLoadingPage] = useState(true);
  const [filters, setFilters] = useState({
    order_by: "az",
    active: 1,
  });

  const [order, setOrder] = useState("A-Z");
  const [users, setUsers] = useState({ data: [] });

  useEffect(() => {
    loadUsers();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const updateFilter = (type, content) => {
    if (type && content) {
      let oldFilters = { ...filters };
      oldFilters[type] = content;
      setFilters(oldFilters);
    }
  };

  async function loadUsers() {
    const params = new URLSearchParams(filters);
    api
      .get(`users?${params.toString()}`, config)
      .then(response => {
        setUsers(response.data);
      })
      .then(() => {
        setLoadingPage(false);
      });
  }

  function redirectEdit(id) {
    navigate(`/users/edit/${id}`);
  }

  const changeOrder = (label, key) => {
    setOrder(label);
    updateFilter("order_by", key);
  };
  return (
    <Main>
      <Content>
        <Row>
          <Col lg={3}>
            <MenuUser />
          </Col>
          {!loadingPage ? (
            <Col>
              <div className="contentPadding">
                <Row>
                  <Col>
                    <div className="d-flex justify-content-between mb-3">
                      <h2 className="form-title">
                        Usuários do sistema <span className="small-label">({users.total} cadastros)</span>
                      </h2>
                      <button onClick={() => navigate(`/users/new`)} className={styleButton.button_ghost}>
                        Novo Usuário
                      </button>
                    </div>
                  </Col>
                </Row>
                <Table className={tableStyle.table}>
                  <thead>
                    <tr>
                      <th style={{ width: "30%" }}>
                        <Dropdown>
                          <Dropdown.Toggle className={tableStyle.dropdownOrder}>
                            CLASSIFICAR: <span>{order}</span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => changeOrder("A-Z", "az")} className="full">
                              A-Z
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => changeOrder("Z-A", "za")} className="full">
                              Z-A
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => changeOrder("Data", "date")} className="full">
                              Data de adição
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </th>
                      <th>SETOR</th>
                      <th>E-MAIL</th>
                      <th>ÚLTIMO ACESSO</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.data.length > 0 &&
                      users.data.map(user => (
                        <tr key={user.id} className="trFlex">
                          <td onClick={() => redirectEdit(user.id)} className={styles.info}>
                            <div className={styles.avatar}>
                              <Avatar username={user.username || ""} />
                            </div>
                            {user.username}
                          </td>
                          <td onClick={() => redirectEdit(user.id)} className="lithInfo">
                            {user.sector}
                          </td>
                          <td onClick={() => redirectEdit(user.id)} className="lithInfo">
                            {user.email}
                          </td>
                          <td onClick={() => redirectEdit(user.id)} className="lithInfo">
                            {user.last_acess ? formatDate(user.last_acess) : "-"}
                          </td>
                          <td onClick={() => redirectEdit(user.id)}>
                            <button className="simple-ico float-right">
                              <IcEditar />
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
                <div className="text-center mt-2">
                  {/* 
                  <Paginacao /> */}
                </div>
              </div>
            </Col>
          ) : (
            <Col>
              <Loading />
            </Col>
          )}
        </Row>
      </Content>
    </Main>
  );
}
